import { memo } from 'react';

import { SegmentedControlRow } from '~/components/ShareModal/components/SegmentedControlRow';
import { useCreateShowcaseDesign } from '~/components/ShowcaseModal/CreateShowcaseDesignProvider';

/**
 * Page theme (color mode) segmented control, bound to the design context. Persists
 * `presentationSettings.colorMode` in edit mode (via the injected commit sink); preview-only in the
 * create modal.
 */
export const CreateShowcaseDesignPageThemeRow = memo(() => {
  const { colorModeOptions, selectedColorModeOption, handleSelectColorMode } = useCreateShowcaseDesign();

  return (
    <SegmentedControlRow
      data-testid="CREATE_COLLECTION_LINK_DESIGN_COLOR_MODE_ROW"
      label="Page theme"
      onSelect={handleSelectColorMode}
      options={colorModeOptions}
      selectedOption={selectedColorModeOption}
    />
  );
});

CreateShowcaseDesignPageThemeRow.displayName = 'CreateShowcaseDesignPageThemeRow';
